import classes from "./SubSystemList.module.css";
import { useEffect, useState, useRef } from "react";
import Entity from "./../UI/panel/entity/Entity";
import { useStore } from "./../../hooks/store";

const SubSystemList = (props) => {
  const [selectSubSystem, setSelectSubSystem] = useState("");
  const [activeType, setActiveType] = useState(null);
  const [sensors, setSensors] = useState([]);
  const [icons, setIcons] = useState([]);
  const [state, dispatch] = useStore();

  useEffect(() => {
    if (state.types.length > 0) {
      const curActiveType = state.types.filter((type) => type.isActive);
      if (curActiveType.length !== -1) {
        setActiveType(curActiveType[0]);
      }
    }
  }, [state.types]);

  useEffect(() => {
    if (state.sensors.length > 0 && activeType) {
      const data = state.sensors.filter(
        (item) => item.typeId === activeType.id
      );

      let activeSensor = "";
      let iconsEachSensor = {};
      for (let i = 0; i < data.length; i++) {
        if (data[i].isActive) {
          activeSensor = data[i];
        }
        iconsEachSensor = {
          ...iconsEachSensor,
          [data[i].id]: data[i].metrics.map((metric) => metric.icon_small),
        };
      }
      console.log(state.sensors);
      console.log(data);
      setSensors(data);
      setIcons(iconsEachSensor);
      setSelectSubSystem(activeSensor);
    }
  }, [state.sensors, activeType]);

  const clickMarkHandler = (item) => {
    if (item !== selectSubSystem) {
      dispatch("CLICKED_SENSOR", item.id);
      setSelectSubSystem(item);
      props.showAnimation(true);
    } else {
      props.showAnimation(false);
    }
  };

  console.log(selectSubSystem);

  let content = null;
  if (activeType) {
    content = (
      <div className={[classes.subsystem_layout].join(" ")}>
        <div
          className={[
            classes.flexContainer,
            classes.subsystem_title_style,
          ].join(" ")}
          style={{ backgroundColor: activeType.color }}
        >
          <p className={classes.subsystem_title}>{activeType.name}</p>
        </div>
        <div className={classes.list_place}>
          <ul>
            {sensors
              .filter((item) => {
                if (props.filterTypeName) {
                  if (
                    item.title
                      .normalize("NFD")
                      .replace(/[\u0300-\u036f]/g, "")
                      .toUpperCase()
                      .includes(
                        props.filterTypeName
                          .normalize("NFD")
                          .replace(/[\u0300-\u036f]/g, "")
                          .toUpperCase()
                      )
                  )
                    return item;
                } else {
                  return item;
                }
              })
              .filter((item) => {
                if (props.filtersVars.length === 0) return item;
                let inlcude = false;
                for (let i = 0; i < item.metrics.length; i++) {
                  for (let y = 0; y < props.filtersVars.length; y++) {
                    if (item.metrics[i].content === props.filtersVars[y]) {
                      inlcude = true;
                      break;
                    }
                  }
                  if (inlcude) break;
                }
                if (inlcude) return item;
              })
              .map((item) => (
                <li
                  key={item.id}
                  style={{ justifyContent: "flex-start" }}
                  className={
                    item.id === selectSubSystem.id
                      ? [classes.flexContainer, classes.active].join(" ")
                      : classes.flexContainer
                  }
                  onClick={() => {
                    clickMarkHandler(item);
                  }}
                >
                  <Entity
                    icon={activeType.icon}
                    title={item.title}
                    address={item.address}
                    icons={icons[item.id]}
                  />
                </li>
              ))}
          </ul>
        </div>
      </div>
    );
  }
  return content;
};

export default SubSystemList;
